<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Secondary Valve Package</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (secondaryValveSizeSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Package Size:</label>
            <select class="halfWidthInputField" #secondaryValveSizeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(secondaryValveSizeSelection.Name)"
              (change)="selectionChanged(secondaryValveSizeSelection, secondaryValveSizeInput.value)"
              [value]="secondaryValveSizeSelection.Value.toString()">
              @for (allowable of secondaryValveSizeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="secondaryValveSizeSelection.Value && secondaryValveSizeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (secondaryStrainerSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Strainer:</label>
            <select class="halfWidthInputField" #secondaryStrainerInput
              [class.invalidConfigurationSelection]="isInvalidSelection(secondaryStrainerSelection.Name)"
              (change)="selectionChanged(secondaryStrainerSelection, secondaryStrainerInput.value)"
              [value]="secondaryStrainerSelection.Value.toString()">
              @for (allowable of secondaryStrainerSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="secondaryStrainerSelection.Value && secondaryStrainerSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (secondaryControlValveSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Control Valve:</label>
            <select class="halfWidthInputField" #secondaryControlValveInput
              [class.invalidConfigurationSelection]="isInvalidSelection(secondaryControlValveSelection.Name)"
              (change)="selectionChanged(secondaryControlValveSelection, secondaryControlValveInput.value)"
              [value]="secondaryControlValveSelection.Value.toString()">
              @for (allowable of secondaryControlValveSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="secondaryControlValveSelection.Value && secondaryControlValveSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (secondaryFlowControlSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Flow Control Type:</label>
            <select class="halfWidthInputField" #secondaryFlowControlInput
              [class.invalidConfigurationSelection]="isInvalidSelection(secondaryFlowControlSelection.Name)"
              (change)="selectionChanged(secondaryFlowControlSelection, secondaryFlowControlInput.value)"
              [value]="secondaryFlowControlSelection.Value.toString()">
              @for (allowable of secondaryFlowControlSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="secondaryFlowControlSelection.Value && secondaryFlowControlSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (secondaryIsolationBallValveSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Isolation Ball Valve:</label>
            <select class="halfWidthInputField" #secondaryIsolationBallValveInput
              [class.invalidConfigurationSelection]="isInvalidSelection(secondaryIsolationBallValveSelection.Name)"
              (change)="selectionChanged(secondaryIsolationBallValveSelection, secondaryIsolationBallValveInput.value)"
              [value]="secondaryIsolationBallValveSelection.Value.toString()">
              @for (allowable of secondaryIsolationBallValveSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="secondaryIsolationBallValveSelection.Value && secondaryIsolationBallValveSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (secondaryIsolationSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Hose Kit:</label>
            <select class="halfWidthInputField" #secondaryIsolationInput
              [class.invalidConfigurationSelection]="isInvalidSelection(secondaryIsolationSelection.Name)"
              (change)="selectionChanged(secondaryIsolationSelection, secondaryIsolationInput.value)"
              [value]="secondaryIsolationSelection.Value.toString()">
              @for (allowable of secondaryIsolationSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="secondaryIsolationSelection.Value && secondaryIsolationSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (secondaryServiceFittingSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Service Fittings:</label>
            <select class="halfWidthInputField" #secondaryServiceFittingsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(secondaryServiceFittingSelection.Name)"
              (change)="selectionChanged(secondaryServiceFittingSelection, secondaryServiceFittingsInput.value)"
              [value]="secondaryServiceFittingSelection.Value.toString()">
              @for (allowable of secondaryServiceFittingSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="secondaryServiceFittingSelection.Value && secondaryServiceFittingSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (secondaryBalanceOnBypassSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(secondaryBalanceOnBypassSelection.Name)"
            for="secondaryBalanceOnBypassInput" class="halfWidthInputLabel">Balance on Bypass:</label>
            <input type="checkbox" class="checkboxInput" id="secondaryBalanceOnBypassInput"
              #secondaryBalanceOnBypassInput [checked]="'true' === secondaryBalanceOnBypassSelection.Value"
              (change)="selectionChanged(secondaryBalanceOnBypassSelection, secondaryBalanceOnBypassInput.checked.toString())">
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        <span class="halfWidthConfigurationInput"></span>
        @if (secondaryNormallyOpenSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(secondaryNormallyOpenSelection.Name)"
            for="secondaryNormallyOpenInput" class="halfWidthInputLabel">Normally Open:</label>
            <input type="checkbox" class="checkboxInput" id="secondaryNormallyOpenInput"
              #secondaryNormallyOpenInput [checked]="'true' === secondaryNormallyOpenSelection.Value"
              (change)="selectionChanged(secondaryNormallyOpenSelection, secondaryNormallyOpenInput.checked.toString())">
          </span>
        }
      </div>
    </div>
  }
</div>
